// removed by extract-text-webpack-plugin
module.exports = {"shippingTitle":"shipping-styles__shippingTitle__3wffv"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/shipping-styles.scss
// module id = 1257
// module chunks = 4 14